import React, { Component } from 'react'
import { Trans, withI18nProps } from '@lingui/react'

import Footer from 'client/shared/blocks/footer'
import Spacer from 'client/shared/blocks/spacer'
import Linka from 'client/shared/blocks/linka/linka'

import { Heading } from 'client/shared/blocks/heading'
import { Locale } from 'client/shared/types/current-user'
import { News } from 'client/bookmate/blocks/press-layout/news'

import {
  screensEn,
  screensRu,
  logos,
  Asset,
} from 'client/bookmate/blocks/press-layout/data/assets'
import './press-layout.styl'

type Props = {
  locale: Locale
} & withI18nProps

class _PressLayout extends Component<Props> {
  getAssets(locale: string): Asset[] {
    switch (locale) {
      case 'ru':
        return screensRu
      default:
        return screensEn
    }
  }

  renderPressAsset(assets: Asset[]): JSX.Element {
    return (
      <>
        {assets.map(({ img, links }) => (
          <div className="asset__item">
            <img src={img} className="asset__image" alt="Bookmate image" />
            <div className="asset__links">
              {Object.entries(links).map(([title, link], i) => (
                <>
                  <Linka
                    className="asset__item-link"
                    path={link}
                    target="_blank"
                  >
                    {title}
                  </Linka>
                  {i === 0 && <>&nbsp;&nbsp;</>}
                </>
              ))}
            </div>
          </div>
        ))}
      </>
    )
  }

  render(): JSX.Element {
    const { locale } = this.props

    return (
      <div className="press-layout">
        <Spacer size="top-page" />
        <section>
          <News locale={locale} />
        </section>
        <Spacer size={56} />
        <section>
          <Heading kind="kazimir" rank={2} looksLike={1}>
            <Trans id="press.press_images" />
          </Heading>
          <Spacer size={32} />
          <div className="assets">
            <div className="assets__images">
              {this.renderPressAsset(this.getAssets(locale))}
            </div>
            <div className="assets__logos">{this.renderPressAsset(logos)}</div>
          </div>
        </section>
        <Spacer size={56} />
        <section>
          <Heading kind="kazimir" rank={2} looksLike={1}>
            <Trans id="press.contact" />
          </Heading>
          <Spacer size={32} />
          <a href="mailto:pr@bookmate.com">pr@bookmate.com</a>
        </section>
        <Spacer size={56} />
        <Footer aboutMenu />
        <Spacer size={48} />
      </div>
    )
  }
}

export const PressLayout = _PressLayout
